export enum Endpoints {
  SORT_PRODUCTS = 'v1/articles/sort',
  SWAP_COMMEDATIONS = 'v2/articles/rank',
  STATUS = 'ping'
}

export enum Events {
  API_CALL = 'api_call'
}

export type ServiceOptions = {
  isKiosk: boolean;
  dev: boolean;
  cookieConsent: boolean;
  dexfApiKey: string;
  countryCode: string;
};

export type SwapCommendationsResult = {
  model: {
    name: string;
    default: boolean;
    ab_name: string;
  };
  recommended: string[];
  scores: number[];
};
